import React from 'react';
import { ConfiguratorUIElementStates } from '@/stores/CfgUIElementState';
import { Button } from '@canvas-logic/clp-shared-ui';
import classNames from 'classnames';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

export const ContainerCfgUIElement = ({
  viewElement,
  childrenItems,
}: {
  childrenItems: ConfiguratorUIElementStates[];
  viewElement: IUiCfgContainer;
}) => {
  const [expanded, setExpanded] = React.useState(!viewElement.expandable || !!viewElement.defaultExpanded);

  const expandable = viewElement.expandable;

  return (
    <div
      className={classNames('cp-container', expanded && 'cp-container--expanded')}
      data-element-id={viewElement.id}
      key={viewElement.id}
    >
      {!!viewElement.title && (
        <div className={'cp-container__title'}>
          <div className={'cp-container__title__text'}>{viewElement.title}</div>
          {expandable && (
            <div className={'cp-container__title__collapsible'}>
              <Button
                variant="ghost"
                iconStart={expanded ? 'chevronUp' : 'chevronDown'}
                onClick={() => setExpanded(!expanded)}
              />
            </div>
          )}
        </div>
      )}

      {expanded && <div className={'cp_container__content'}>{childrenItems.map((child) => child.render())}</div>}
    </div>
  );
};
